// 买贵赔

export default [
    {
        path: '/indemnityHis',
        redirect: { name: 'IndemnityHisIndex' },
    },
    {
        path: '/indemnityHis/index',
        component: () => import(/* webpackChunkName:"indemnity"*/'@/pages/indemnityHis/index.vue'),
        name: 'IndemnityHisIndex',
        meta: {
            title: '',
        },
    },
    {
        path: '/indemnityHis/record',
        component: () => import(/* webpackChunkName:"indemnity"*/'@/pages/indemnityHis/record.vue'),
        name: 'IndemnityHisRecord',
        meta: {
            title: '赔付记录',
        },
    },
    {
        path: '/indemnityHis/list',
        component: () => import(/* webpackChunkName:"indemnity"*/'@/pages/indemnityHis/list.vue'),
        name: 'IndemnityHisList',
        meta: {
            title: '申请赔付',
        },
    },
    {
        path: '/indemnityHis/detail',
        component: () => import(/* webpackChunkName:"indemnity"*/'@/pages/indemnityHis/detail.vue'),
        name: 'IndemnityHisDetail',
        meta: {
            title: '申请赔付',
        },
    },
    {
        path: '/indemnityHis/success',
        component: () => import(/* webpackChunkName:"indemnity"*/'@/pages/indemnityHis/success.vue'),
        name: 'IndemnityHisSuccess',
        meta: {
            title: '申请成功',
        },
    },
    {
        path: '/indemnityHis/rules',
        component: () => import(/* webpackChunkName:"indemnity"*/'@/pages/indemnityHis/rules.vue'),
        name: 'IndemnityHisRules',
        meta: {
            title: '详细规则',
        },
    },
];
